<template>
    <div class="card-wrapper mb-4">
        <component :is="isMuted ? 'div' : 'a'" :href="shouldGoToUri" class="card course artist h-100 w-100" :class="{ 'muted': isMuted }">
            <div class="card-body">
                <div class="text-center img-wrap">
                    <img class="card-img-top-virtuoso h-auto" :src="artist.imageUris ? artist.imageUris.cardThumb.url : ''"
                         :alt="artist.name"
                         loading="lazy"
                         width="320"
                         height="180">
                </div>

                <h2 class="grey-subtitle mb-2">{{ artist.name }}</h2>

                <p class="black-text bio" v-if="artist.card_bio" v-html="artist.card_bio"></p>

                <div class="black-text badges genres" v-if="artist.genresFormatted" v-html="artist.genresFormatted"></div>

                <div class="badges" v-if="type === 'artist' && artist.availableProducts">
                    <span class="badge badge-pill badge-secondary mr-2" v-for="product in artist.availableProducts" :key="product">{{ product }}</span>
                </div>

                <!-- Mentoring disabled -->
                <!--
                <div class="badges skills" v-if="type === 'mentoring' && artist.skillsFormatted" v-html="artist.skillsFormatted"></div>

                <div v-if="type === 'mentoring'">
                    <div class="black-text" v-if="artist.mentoring_duration">
                        <p><strong>{{ artist.mentoring_duration }}</strong></p>
                    </div>
                    <p class="mb-0">{{ artist.mentoringPriceFormatted }}</p>
                </div>
                -->

                <p class="mb-0 mt-2" v-if="type === 'feedback'">
                    Normal price: {{ artist.feedbackPriceFormatted }}<br>
                    Premium Member price: {{ artist.feedbackPriceSubscriptionFormatted }}
                </p>
            </div>
        </component>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            artistData: {
                type: Object,
                default: null
            },
            muted: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'artist'
            }
        },

        data() {
            return {
                artist: {},
                isMuted: false,
            }
        },

        computed: {
            shouldGoToUri: function () {
                return this.artist.uri;
            }
        },

        mounted() {
            this.artist = this.artistData;

            // Prop option
            if(this.muted === true) {
                this.isMuted = true;
            }
        },

        methods: {
        }
    }
</script>
